import type { QuestionSingleData } from '@repo/types/questions/QuestionSingle';

import { Markdown } from '@/components/ui/markdown';

interface QuestionMarkedSingleContentProps {
  question: QuestionSingleData;
}

export function QuestionMarkedSingleContent(questionMarkedSingleContentProps: QuestionMarkedSingleContentProps) {
  const { question } = questionMarkedSingleContentProps;
  return (
    <ul className="list-outside list-disc space-y-2 ps-4.5">
      {question.answers.map((answer) => (
        <li key={answer.id}>
          <Markdown content={answer.content} imageClassName="max-h-68 rounded-sm" videoClassName="max-h-68 rounded-sm" />
        </li>
      ))}
    </ul>
  );
}
